import { useId } from "react";

type LogoMarkBaseProps = {
  /** The painted mark inherits currentColor; circle reverses it on a solid field. */
  variant?: "line" | "circle";
  /** Retained for callers; the painted brush texture defines its own weight. */
  weight?: "icon" | "lockup";
  className?: string;
};

type LogoMarkProps = LogoMarkBaseProps &
  ({ decorative: true; title?: never } | { decorative?: false; title: string });

/** Use the approved artwork's alpha as a mask, preserving texture on any surface. */
export function LogoMark({
  variant = "line",
  className,
  decorative,
  title,
}: LogoMarkProps) {
  const maskId = `painted-mark-${useId().replace(/:/g, "")}`;
  const accessibilityProps = decorative
    ? ({ "aria-hidden": true } as const)
    : ({ role: "img", "aria-label": title } as const);

  return (
    <svg
      viewBox={variant === "circle" ? "0 0 1254 1254" : "190 140 880 960"}
      className={className}
      {...accessibilityProps}
    >
      <defs>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="1254"
          height="1254"
          style={{ maskType: "alpha" }}
        >
          <image
            href="/brand/resimo-probleme-mark-runtime-mask.png"
            width="1254"
            height="1254"
          />
        </mask>
      </defs>
      {variant === "circle" && (
        <circle cx="627" cy="627" r="627" fill="currentColor" />
      )}
      <g
        transform={
          variant === "circle" ? "translate(188 188) scale(.7)" : undefined
        }
      >
        <rect
          width="1254"
          height="1254"
          fill={variant === "circle" ? "white" : "currentColor"}
          mask={`url(#${maskId})`}
        />
      </g>
    </svg>
  );
}

export default LogoMark;
